/*

This is where you define your action creators. 
All action creators must be functions that return an object 
with at least the type property. 
We do not define any async logic in this file.

*/

// eslint-disable-next-line import/extensions
import types from './types.js';

const requestUserDetails = () => ({
  type: types.REQUEST_USER_DETAILS
});

const receiveUserDetails = (
  patient,
  patientSessions,
  sort,
  sortOrder,
  filters
) => ({
  type: types.RECEIVE_USER_DETAILS,
  patient,
  patientSessions,
  sort,
  sortOrder,
  filters
});

const requestRecordings = () => ({
  type: types.REQUEST_SESSION_RECORDINGS
});

const receiveRecordings = (
  recordings,
  sortRecordings,
  sortOrderRecordings,
  filters
) => ({
  type: types.RECEIVE_SESSION_RECORDINGS,
  recordings,
  sortRecordings,
  sortOrderRecordings
});

const requestSaveSessionInfo = () => ({
  type: types.REQUEST_SAVE_SESSION_INFO
});

const savedSessionInfo = (sessions, message) => ({
  type: types.SAVED_SESSION_INFO,
  sessions,
  message
});

const updateUserDetail = data => ({
  type: types.UPDATE_USER_DETAILS,
  data
});

const requestTopicQuestions = () => ({
  type: types.REQUEST_TOPIC_QUESTIONS,
});

const receiveTopicQuestions = data => ({
  type: types.RECEIVE_TOPIC_QUESTIONS,
  data
})


export {
  requestRecordings,
  receiveRecordings,
  requestUserDetails,
  receiveUserDetails,
  requestSaveSessionInfo,
  savedSessionInfo,
  updateUserDetail,
  requestTopicQuestions,
  receiveTopicQuestions

};
